// Parsea "DD/MM/YYYY" a número YYYYMMDD para ordenar cronológicamente
const toNum = (item) => {
  const s = item?.fechaactualizacion;
  if (!s) return 0;
  const [d, m, y] = s.split('/');
  return parseInt(y + m.padStart(2, '0') + d.padStart(2, '0'), 10);
};

// Filtra por idpresa y ordena desc: [0]=más reciente, [1]=año anterior, [2]=hace 2 años
const byId = (objeto, id) =>
  objeto.filter((item) => item.idpresa === id).sort((a, b) => toNum(b) - toNum(a));

export const NivelesSinaloa = (objeto) => {
  return {
    luisdonaldo:     byId(objeto, "LDCSI")[0],
    miguelhidalgo:   byId(objeto, "PMHSI")[0],
    guillermoblake:  byId(objeto, "GBESI")[0],
    gustadodiaz:     byId(objeto, "GDOSI")[0],
    adolfolopez:     byId(objeto, "ALMSI")[0],
    juanguerra:      byId(objeto, "JGRSI")[0],
    aurelio:         byId(objeto, "SLTSI")[0],
    josefaortiz:     byId(objeto, "JORSI")[0],
    eustaquiobuelna: byId(objeto, "EBLSI")[0],
    sanalona:        byId(objeto, "SNLSI")[0],
    joselopez:       byId(objeto, "JLPSI")[0],
    total:           byId(objeto, "TTTTS")[0],
  };
};

export const NivelesNayarit = (objeto) => {
  return {
    aguamilpa:        byId(objeto, "AGMNR")[0],
    leonardorodriguez: byId(objeto, "CJNNR")[0],
    sanrafael:        byId(objeto, "RSRNR")[0],
    layesca:          byId(objeto, "PLYJL")[0],
    total:            byId(objeto, "TTTTN")[0],
  };
};

export const NivelesSinaloaMenos1 = (objeto) => {
  return {
    luisdonaldo:     byId(objeto, "LDCSI")[1],
    miguelhidalgo:   byId(objeto, "PMHSI")[1],
    guillermoblake:  byId(objeto, "GBESI")[1],
    gustadodiaz:     byId(objeto, "GDOSI")[1],
    adolfolopez:     byId(objeto, "ALMSI")[1],
    juanguerra:      byId(objeto, "JGRSI")[1],
    aurelio:         byId(objeto, "SLTSI")[1],
    josefaortiz:     byId(objeto, "JORSI")[1],
    eustaquiobuelna: byId(objeto, "EBLSI")[1],
    sanalona:        byId(objeto, "SNLSI")[1],
    joselopez:       byId(objeto, "JLPSI")[1],
    total:           byId(objeto, "TTTTS")[1],
  };
};

export const NivelesNayaritMenos1 = (objeto) => {
  return {
    aguamilpa:        byId(objeto, "AGMNR")[1],
    leonardorodriguez: byId(objeto, "CJNNR")[1],
    sanrafael:        byId(objeto, "RSRNR")[1],
    layesca:          byId(objeto, "PLYJL")[1],
    total:            byId(objeto, "TTTTN")[1],
  };
};

export const NivelesSinaloaMenos2 = (objeto) => {
  return {
    luisdonaldo:     byId(objeto, "LDCSI")[2],
    miguelhidalgo:   byId(objeto, "PMHSI")[2],
    guillermoblake:  byId(objeto, "GBESI")[2],
    gustadodiaz:     byId(objeto, "GDOSI")[2],
    adolfolopez:     byId(objeto, "ALMSI")[2],
    juanguerra:      byId(objeto, "JGRSI")[2],
    aurelio:         byId(objeto, "SLTSI")[2],
    josefaortiz:     byId(objeto, "JORSI")[2],
    eustaquiobuelna: byId(objeto, "EBLSI")[2],
    sanalona:        byId(objeto, "SNLSI")[2],
    joselopez:       byId(objeto, "JLPSI")[2],
    total:           byId(objeto, "TTTTS")[2],
  };
};

export const NivelesNayaritMenos2 = (objeto) => {
  return {
    aguamilpa:        byId(objeto, "AGMNR")[2],
    leonardorodriguez: byId(objeto, "CJNNR")[2],
    sanrafael:        byId(objeto, "RSRNR")[2],
    layesca:          byId(objeto, "PLYJL")[2],
    total:            byId(objeto, "TTTTN")[2],
  };
};
